import pages from './constants'
import { driver } from 'driver.js'
import { complianseSteps } from './page.compliance'
import ActionType from '../store/action.types'
import {
  updateUserVisitedPages,
  getUserVisitedPages,
} from '../store/action/user.action'
import { surgeonSteps } from './page.surgeon'
import { patientInfoFormSteps, patientSteps } from './page.patient'
import {
  deviceScheduleSteps,
  exeScheduleSteps,
  feedScheduleSteps,
  regimenScheduleSteps,
  selectCarePlanSteps,
} from './page.schedule'
import { addUserSteps, userListSteps } from './page.user'
import { messageSteps } from './page.message'
import { remainderSteps } from './page.reminder'
import { supportSteps } from './page.support'
import { constants } from '../constants'

let getTutorial = (page, forceHelp = false) => {
  let { ROLE } = constants
  getUserVisitedPages()().then((res) => {
    let pageVisited = res
    let customerUsers = [
      ROLE.SURGEON,
      ROLE.MEDICAL_ASSOCIATE,
      ROLE.ADMIN,
      ROLE.PHYSIO,
    ]
    let canShowHelp =
      forceHelp ||
      (!pageVisited.includes(page) &&
        customerUsers.includes(
          window.redux_store.getState().profile.user.role + ''
        ))

    if (!canShowHelp) return

    let steps = []
    switch (page) {
      case pages.COMPLIANCEPAGE:
        steps = complianseSteps
        break
      case pages.SURGEONPAGE:
        steps = surgeonSteps
        break
      case pages.PATIENTLIST:
        steps = patientSteps
        break
      case pages.ADDPATIENT:
        steps = patientInfoFormSteps
        break
      case pages.SELECTCAREPLAN:
        steps = selectCarePlanSteps
        break
      case pages.DEVSCHED:
        steps = deviceScheduleSteps
        break
      case pages.ASSIGNREGIMEN:
        steps = regimenScheduleSteps
        break
      case pages.EXESCHED:
        steps = exeScheduleSteps
        break
      case pages.FEEDSCHED:
        steps = feedScheduleSteps
        break
      case pages.USERLIST:
        steps = userListSteps
        break
      case pages.ADDUSER:
        steps = addUserSteps
        break
      case pages.MESSAGES:
        steps = messageSteps
        break
      case pages.REMINDER:
        steps = remainderSteps
        break
      case pages.SUPPORT:
        steps = supportSteps
        break
    }

    driver({
      animate: false,
      showProgress: false,
      onDestroyed: () => {},
      popoverClass: 'driverjs-theme',
      steps,
    }).drive()
    updateUserVisitedPages(page, window.redux_store.dispatch)()
  })
}

export default getTutorial
